/**
 * Implement tracking using Adobe Analytics.
 */
class AdobeMain {
	/**
	 * collect object from queue and push it in digitalData for Adobe Analytics
	 * @param {Object} dataObj - collections of events objects
	 * @example
	 * handleDigitalDataPush({event: 'ctaClick', title: document.title}, callback)
	 */
	handleDigitalDataPush( dataObj = null ) {
		if ( dataObj && window.digitalData ) {
			window.adobeDataLayer.push( dataObj );
		}
	}
}

const instance = new AdobeMain();

export default instance;
